// Mixin for TM BIDING EVENTS and methods

import 'custom-event-polyfill'
import chatIdentifiers from '@/helpers/chatIdentifiers'

export default {
  data() {
    return {
      tmMixin_provider: null,
      events: {},
    }
  },
  computed: {
    $_tmMixin_layerAvailable() {
      return Object.values(this.$enum.TM_PROVIDER).includes(
        this.tmMixin_provider,
      )
    },
  },
  methods: {
    /**
     * @description Find and set TM provider
     */
    $_tmMixin_setProvider() {
      if (window?.tC) {
        this.tmMixin_provider = this.$enum.TM_PROVIDER.TAG_COMMANDER
        // tagCommander: put in debug mode if development
        if (process.env.NODE_ENV !== 'production') {
          tC.setCookie('tCdebugLib', 1)
          console.info('containerVersion:', tC.containerVersion)
        }
      } else if (window?._mtm) {
        this.tmMixin_provider = this.$enum.TM_PROVIDER.MATOMO
      } else if (window?.[chatIdentifiers.layer]) {
        this.tmMixin_provider = this.$enum.TM_PROVIDER.GTM
      }
    },
    /**
     * @description Send event to TM
     * @param {object} event
     * @param {object} payload
     */
    $_tmMixin_pushDataLayer({ event, ...payload }) {
      const detail = this.$_tmMixin_sanitizeObject(payload)
      if (this.$_tmMixin_layerAvailable) {
        if (this.tmMixin_provider === this.$enum.TM_PROVIDER.GTM) {
          window[chatIdentifiers.layer].push({ event, ...payload })
        } else if (this.tmMixin_provider === this.$enum.TM_PROVIDER.MATOMO) {
          window['_mtm'].push({ event, ...payload })
        } else {
          for (const [name, value] of Object.entries(detail)) {
            window.tC.internalvars[name] = value
          }
          const tCEvent = window.tC.event[event]
          if (tCEvent && typeof tCEvent === 'function') {
            tCEvent()
          }
        }
      }

      // Dispatch custom event to allow chat-in-app to react
      const chatEvent = new CustomEvent(event, { detail })
      window.dispatchEvent(chatEvent)
    },
    /**
     * @description Retrieve dataLayer value
     * @param {string} property
     */
    $_tmMixin_getDataLayerProperty(property) {
      if (this.$_tmMixin_layerAvailable) {
        if (this.tmMixin_provider === this.$enum.TM_PROVIDER.GTM) {
          for (const item of window[chatIdentifiers.layer]) {
            if (item[property]) return item[property]
          }
        } else if (this.tmMixin_provider === this.$enum.TM_PROVIDER.MATOMO) {
          return MatomoTagManager.dataLayer.get(property)
        } else {
          const tagCoProperty = this.$_tmMixin_sanitizeDataName(property)
          return window.tC.internalvars[tagCoProperty]
        }
      } else {
        console.error(
          'getDataLayerProperty: No dataLayer found or loaded',
          property,
        )
      }
      return null
    },
    /**
     * @description Rewrite DataLayer property name for tagCommander
     * @param {string} name
     */
    $_tmMixin_sanitizeDataName(name) {
      return name.replace(/\./g, '_')
    },
    $_tmMixin_WidgetReady(type, sessionCount) {
      const options = {
        event: this.$enum.TM_EVENT.WIDGET_READY,
        'innso.widgetReady': 'true',
        'innso.widgetType': type,
      }

      if (sessionCount) {
        const typeSanitize =
          type.toLowerCase().charAt(0).toUpperCase() +
          type.toLowerCase().slice(1)
        options[`'innso.widget${typeSanitize}SessionCount'`] = sessionCount
      }

      this.$_tmMixin_pushDataLayer(options)
    },
    $_tmMixin_sanitizeObject(payload) {
      return Object.keys(payload).reduce((acc, key) => {
        const sanitizedName = this.$_tmMixin_sanitizeDataName(key)
        acc[sanitizedName] = payload[key]
        return acc
      }, {})
    },
  },
  created() {
    this.$_tmMixin_setProvider()
  },
  mounted() {
    /**
     * @description  Check if vue component have TM entry and then bind event listener to each entry
     */
    if (this.$options.tm) {
      for (const event in this.$options.tm) {
        this.events[event] = this.$options.tm[event].bind(this)
        window.addEventListener(event, this.events[event])
      }
    }
  },

  beforeDestroy() {
    /**
     * @description  Unbind TM event listener
     */
    if (this.$options.tm) {
      for (const event in this.$options.tm) {
        if (this.events[event]) {
          window.removeEventListener(event, this.events[event])
        }
      }
    }
  },
}
